import styled from 'styled-components'

export const Container = styled.div`
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 10px 0 0;
    /* width: 100%; */

    div {
        width: 100%;
        .MuiTextField-root {
            .MuiOutlinedInput-root {
                height: 60px;
            }
        }
    }
`
